import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from '../shared/primeng.module';
import { MaterialModuleModule } from '../material-module/material-module/material-module.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { ContactUsConnectRouting } from './contact-us-connect-routing.module';
import { BreadcrumbModule } from 'primeng/breadcrumb';



@NgModule({
  declarations: [
    ContactUsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    PrimengModule,
    MaterialModuleModule,
    MatTooltipModule,
    MatTabsModule,
    ContactUsConnectRouting,
    BreadcrumbModule
  ]
})
export class ContactUsConnectModule { }
